class BlogSwiper2 extends window.HTMLElement {
  constructor() {
    super();
    this.initSwiper();
  }
  initSwiper() {
    $(this)
      .find(".blog-swiper-1")
      .slick({
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  }
}
window.customElements.define("blog-swiper", BlogSwiper2);
